module.exports = __webpack_public_path__ + "img/edit1.ff3eadec.svg";